import React from 'react';
import sanitizeHtml from 'sanitize-html';

import { activateRichTextHtml } from '../util';

export default function RichTextContent (props) {
  const { Component = 'div', html = '', ...extraProps } = props;

  return (
    <Component
      dangerouslySetInnerHTML={{
        __html: sanitizeHtml(activateRichTextHtml(html), {
          allowedTags: [...sanitizeHtml.defaults.allowedTags, 'img', 'video', 'audio', 'h2'],
          allowedAttributes: {
            ...sanitizeHtml.defaults.allowedAttributes,
            // width/height はあえて許可しない。既存記事の img が持つ実寸(例 width="800")が
            // 効き始めて表示が変わってしまうため。アイコンのサイズは data-icon 経由でCSSが決める。
            img: [...sanitizeHtml.defaults.allowedAttributes.img, 'style', 'data-icon'],
            video: ['src', 'controls', 'poster', 'style'],
            audio: ['src', 'controls', 'style'],
            a: ['href', 'target'],
          },
        }),
      }}
      className="app-rte"
      {...extraProps}
    />
  );
}
